

<template>
	<div class="nav-optionen h-100 d-flex flex-column">
		
		<h3 class="title p-3 px-4">
			{{ title }}
			<a @click="onClickClose( $event )" class="close p-4"><i class="fas fa-times"></i></a>
		</h3>

		<div class="scrollable p-6 pb-10">
			<div class="d-flex flex-wrap">		
				<template v-for="item, v in optionen">

					<template v-if="!item.result[optName].farben">
						<div class="col-6 col-md-4 p-0 option-box">
							<a class="btn-option p-3" 
								:class="{selected:item.selected, conflicts:!item.selectable}"
								@click="onClickOption( item, $event )">

								<transition name="zoom">
									<span class="checker" v-if="item.selected">
										<i class="fas fa-check-circle"></i>
									</span>
								</transition>

								<div class="px-4 image" v-if="item.result[optName].img">
									<img :src="getMediaPath(item.result[optName].img)" class="img-fluid w-100" />	
								</div>
								{{ item.result[optName].title }}
								<!-- {{ item.result[optName].typ }} {{ item.result.uid }} -->
							</a>
						</div>
					</template>

					<template v-if="item.result[optName].farben">

						<div v-for="farbe in item.result[optName].farben" class="col-6 col-md-4 p-0 option-box">
							<a class="btn-option p-3" 
								:class="{selected:(item.selected && farbe.typ == closestColor)}" 
								@click="onClickFarbe( item, farbe, $event )">

									<transition name="zoom">
										<span class="checker" v-if="item.selected && farbe.typ == closestColor">
											<i class="fas fa-check-circle"></i>
										</span>
									</transition>

									<div class="px-4 image" v-if="item.result[optName].img">
										<img :src="getMediaPath(farbe.img ? farbe.img : item.result[optName].img)" class="img-fluid w-100" />	
									</div>
									{{ item.result[optName].title }} {{farbe.title}}
									<!-- {{ item.result.uid }} -->
							</a>
						</div>

					</template>

				</template>
			</div>
		</div>

		<div class="tabbar mt-auto p-3 px-4 d-flex">
			<a class="btn-remove" @click="onClickUnset( $event )">
				<i class="fas fa-times mr-1"></i> {{ LL('remove') }}
			</a>
			<a class="ml-auto btn-apply" @click="onClickClose( $event )">
				<i class="fas fa-check mr-1"></i> {{ LL('apply') }}
			</a>
		</div>

	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'
import { Log } from '@/services/log.service'
import { Finder } from '@/services/finder.service'

export default {
	store,
	props: ['options', 'title', 'optName', 'filters', 'globalFilters', 'color'],
	data: () => {
		return {
			closestColor: false,
		}
	},
	computed: {
		...mapState('configurator', ['configurator', 'kombis']),
		...mapState('settings', ['presets']),

		optionen () {
			var results = Finder.findByCriteria(this.filters, this.optName);
			return results;
		},
	},
	mounted() {
		this.updateClosestColor();
	},
	updated() {
		this.updateClosestColor();
	},

	methods: {
		
		updateClosestColor() {
			var color = false;
			var firstColor = false;
			this.optionen.forEach((item) => {
				if (item.result[this.optName].farben) {
					for (var i in item.result[this.optName].farben) {
						var farbe = item.result[this.optName].farben[i];
						if (!firstColor) firstColor = farbe.typ;
						if (farbe.typ == this.color) color = farbe.typ;
					}
				}
			});
			this.closestColor = color || firstColor;
			if (this.closestColors) console.log(this.closestColors);
		},

		onClickUnset( event ) {
			this.$emit('option-unselected', {optName:this.optName});
		},

		onClickClose( event ) {
			this.$emit('close', {optName:this.optName});
		},

		onClickOption( item, event ) {
			if (item.hasConflicts) {
				// alert('Konflikt mit: ' + Object.keys(item.conflicts) + ' : ' + Object.values(item.conflicts) );
				Log.ERROR( 'NavOptionen.vue', 'onClickOptionen: Nicht auswählbar, weil...', item.conflicts );
				for (var i in item.conflicts) {
					this.$emit('option-unselected', {optName:i, silently:true});
				}
			}
			this.$emit('option-selected', this.createEventParameters(item, event));
		},

		onClickFarbe( item, farbe, event ) {
			this.onClickOption( item, event );
			this.$emit('color-selected', {optName:this.optName, typ:farbe.typ});
			this.$nextTick( this.updateClosestColor );
		},

		createEventParameters( v, event ) {
			var filter = {};
			filter[this.optName] = v.result[this.optName].typ;
			return {
				optName: this.optName,
				filter: filter,
				originalEvent: event,
			};
		}
	}

}
</script>

<style scoped lang="scss">
	.scrollable {
		overflow-y: auto;
		-webkit-overflow: touch;		
	}
	.nav-optionen {
		color: #9cb7d3;
	}
	.option-box {
		border: 1px solid #ddd;
		position: relative;
		margin: 0 -1px -1px 0;
	}
	.btn-option {
		text-align: center;
		font-weight: normal;
		color: #555;
		display: block;
		font-size: 0.8rem;
		cursor: pointer;
		height: 100%;
	}
	.image {
		margin: 0;
	}
	.checker {
		position: absolute;
		right: 10px;
		top: 10px;
		font-size: 1.3rem;
		z-index: 10;
		color: #46a77f;
		animation-duration: 0.2s;
	}
	.selected {
		&:after {
			content: '';
			//background: rgba(#429318, 0.1);
			background: rgba(#a3d7ef, 0.2);
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			z-index: 5;
		}
	}
	.conflicts {
		opacity: 0.3;
		&:hover {
			opacity: 1;
		}
	}
	.colors {
		font-size: 0.7rem;
	}
	.tabbar,
	.title {
		background: #a3d7ef;
		color: #084c91;
		a {
			font-weight: 400;
			text-transform: uppercase;
			letter-spacing: 0.08em;
		}
	}
	.tabbar a {
		font-size: 1rem;
	}
	.title {
		font-size: 1.3rem;
		letter-spacing: 0.08em;
		line-height: 1;
		text-transform: uppercase;
		margin: 0;
		position: relative;
	}
	.close {
		position: absolute;
		right: 0rem;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
	}
	.btn-apply {
		background: #fff;
		padding: 0.25rem 1rem;
		box-shadow: 0 0 4px rgba(#000, 0.3);
	}
	.btn-remove {
		padding: 0.25rem 0;
	}
	a {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/NavOptionen.vue